// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "sequence_version".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { chatbotVersionChangeTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "sequence_version" table (1:1 with a DB row, on the wire). */
export const sequenceVersionAtomSchema = z.object({
    id: z.string(),
    sequenceId: z.string(),
    version: z.number(),
    nodes: z.unknown(),
    edges: z.unknown(),
    changeType: z.enum(chatbotVersionChangeTypeValues),
    changeSummary: z.string().nullable(),
    createdById: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=sequenceVersion.js.map